<template>
  <div class="sort-header-title">
    <span class="text-base text-text-default font-medium">{{ title }}</span>
    <div
      v-if="!isGuestReader"
      class="sort-header-title-button pt"
      @click="$emit('click')"
    >
      <em
        v-if="!iconRightPosition && showIcon"
        class="custom-icons sort-header-title-button-icon"
        :style="getCustomIconStyle(iconPath(iconName))"
      />
      <span class="text-sm text-text-default">{{ buttonText }}</span>
      <em
        v-if="iconRightPosition && showIcon"
        class="custom-icons sort-header-title-button-icon"
        :style="getCustomIconStyle(iconPath(iconName))"
      />
    </div>
  </div>
</template>

<script>
import customIconsMixin from '@/mixins/customIconsMixin';
import useCurrentRole from '@/utilities/composables/useCurrentRole';

export default {
  name: 'SortHeaderTitle',
  mixins: [customIconsMixin],
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    buttonText: {
      type: String,
      required: false,
      default: '',
    },
    iconRightPosition: {
      type: Boolean,
      required: false,
      default: false,
    },
    iconName: {
      type: String,
      required: false,
      default: 'plus',
    },
    showIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  emits: ['click'],

  setup() {
    const { isGuestReader } = useCurrentRole();

    return {
      isGuestReader,
    };
  },
};
</script>

<style lang="scss">
.sort-header-title {
  @apply flex gap-x-4 items-center;

  .sort-header-title-button {
    @apply flex items-center gap-x-1 px-2 py-1 rounded shrink-0;

    .sort-header-title-button-icon {
      @apply bg-icon-default h-4 w-4;
    }

    &:hover {
      @apply bg-hover-default;

      .sort-header-title-button-icon {
        @apply bg-icon-hover;
      }
    }
  }
}
</style>
